import React, { ReactNode } from 'react';
import type { CSSProp } from 'styled-components';

// import { useFormikContext } from 'formik';
import { Field, IFieldProps } from 'common/components/form/Input';
import { useFormikField } from 'common/components/form/useFormikField';
import { FieldWrapper } from 'common/components/form/Wrapper/FieldWrapper';

import { InputIcon, InputWrapperLabel } from './Wrapper.styled';

export interface IFormInput extends IFieldProps {
  icon?: ReactNode;
  onIconClick?: () => void;
  margin?: string;
  width?: string;
  extendedStyles?: CSSProp;
  placeholder?: string;
  placeholderColor?: string;
  padding?: string;
}

export const FormField = ({
  name,
  label,
  icon,
  onIconClick,
  width,
  margin,
  extendedStyles,
  placeholder,
  placeholderColor,
  padding,
  ...rest
}: IFormInput) => {
  const { error, hasError } = useFormikField(name);

  return (
    <FieldWrapper
      name={name}
      label={label}
      isRequired={rest.required || rest.isRequired}
      isDisabled={rest.disabled || rest.isDisabled}
      error={hasError ? `${error}` : undefined}
      margin={margin}
      tooltip={rest.tooltip}
      justifyContentLabel={rest.justifyContentLabel}
      width={width || rest.width}
      labelStyle={rest.labelStyle}
      placeholderColor={placeholderColor}
    >
      <InputWrapperLabel
        $hasError={rest.outsideValidationHasError || hasError}
        $isDisabled={rest.disabled}
        $borderTopRightRadius={rest.borderTopRightRadius}
        $borderBottomRightRadius={rest.borderBottomRightRadius}
        icon={icon}
        $extendedStyles={extendedStyles}
        $padding={padding}
      >
        <Field {...rest} name={name} placeholder={placeholder} />
        {!!icon && (
          <InputIcon
            $hasError={rest.outsideValidationHasError || hasError}
            $isDisabled={rest.disabled}
            onClick={onIconClick}
            width="initial"
            icon={icon}
          >
            {icon}
          </InputIcon>
        )}
      </InputWrapperLabel>
    </FieldWrapper>
  );
};
